import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
export default (function () {
  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }

  return false ? require('identity-obj-proxy') : _Object$assign.apply(void 0, [{}].concat(objects));
});